import { CircularDataTrendIcon } from '@jouzen/ecom-components/icons/CircularDataTrendIcon';
import { CircularLockIcon } from '@jouzen/ecom-components/icons/CircularLockIcon';
import { CircularPersonIcon } from '@jouzen/ecom-components/icons/CircularPersonIcon';

import TwoColumnModule, {
  type TextColProps,
} from '@/app/components/TwoColumnModule';

export const motionProps = {
  initial: { filter: 'blur(5px)', opacity: 0 },
  style: { height: '100%' },
  transition: { delay: 0.5, duration: 0.5 },
  viewport: { once: true },
  whileInView: { filter: 'blur(0px)', opacity: 1 },
};
const textClassName = 'text-base lg:text-xl';
export const textCol: TextColProps = {
  titleProps: {
    label: 'science_and_research_oura_advisor_title',
    className: 'mb-6 lg:mb-8',
    Element: 'h3',
    height: 'tight',
    variant: 'h4',
  },
  paragraphs: [
    {
      icon: CircularDataTrendIcon,
      textProps: {
        label: 'science_and_research_oura_advisor_text_1',
        className: textClassName,
      },
    },
    {
      icon: CircularPersonIcon,
      textProps: {
        label: 'science_and_research_oura_advisor_text_2',
        className: textClassName,
      },
    },
    {
      icon: CircularLockIcon,
      textProps: {
        label: 'science_and_research_oura_advisor_text_3',
        className: textClassName,
      },
    },
  ],
};

const ScienceAndResearchAdvisor = () => {
  return (
    <TwoColumnModule
      imageCol={{
        localizedAlt: 'science_and_reasearch_oura_advisor_img_alt',
        motionProps,
        src: 'blue-sky/science-and-research/oura-advisor-app-view-3',
      }}
      smBreakTextPos="bottom"
      mdBreakTextPos="left"
      textCol={textCol}
    />
  );
};

export default ScienceAndResearchAdvisor;
